import React from 'react';
export function defaultLabelBehaviour(_ref) {
  var a11yLabel = _ref.a11yLabel,
    label = _ref.label;
  return !a11yLabel ? label : React.createElement("span", {
    "aria-hidden": "true"
  }, label);
}
export function srOnlySpanLabel() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$a11yActiveLabel = _ref2.a11yActiveLabel,
    a11yActiveLabel = _ref2$a11yActiveLabel === void 0 ? '(current)' : _ref2$a11yActiveLabel,
    _ref2$srOnlyClassName = _ref2.srOnlyClassName,
    srOnlyClassName = _ref2$srOnlyClassName === void 0 ? 'sr-only' : _ref2$srOnlyClassName;
  return function (item) {
    var activePage = item.gotoPage !== undefined && item.active;
    var srOnlyLabel = activePage && a11yActiveLabel ? " ".concat(a11yActiveLabel) : item.a11yLabel;
    return React.createElement(React.Fragment, null, !item.a11yLabel ? item.label : React.createElement("span", {
      "aria-hidden": "true"
    }, item.label), srOnlyLabel && React.createElement("span", {
      className: srOnlyClassName
    }, srOnlyLabel));
  };
}